// {project}/src/wasmJsMain/resources/databaseUtils.mjs

export async function deleteDatabase(prefix, except = "") {
    const tables = await indexedDB.databases();
    console.log(`Found ${tables.length} tables`, tables);

    const tablesToDelete = tables.filter((db) => db.name.startsWith(prefix) && db.name !== except);
    console.log(`Tables to remove ${tablesToDelete.length}:`, tablesToDelete);

    if (tablesToDelete.length === 0) {
        return true;
    }

    return new Promise((resolve, reject) => {
        let completedCount = 0;

        const timeout = setTimeout(() => {
            console.warn(`deleteDatabase timed out: ${completedCount}/${tablesToDelete.length} deleted`);
            resolve(false);
        }, 10_000);

        for (const db of tablesToDelete) {
            console.log(`- Name: ${db.name}, Version: ${db.version}`);

            const request = indexedDB.deleteDatabase(db.name);

            request.onsuccess = () => {
                console.log(`Database ${db.name} successfully deleted`);
                if (++completedCount === tablesToDelete.length) {
                    clearTimeout(timeout);
                    resolve(true);
                }
            };

            request.onerror = (event) => {
                console.error(`Error deleting database ${db.name}:`, event.target.error);
                clearTimeout(timeout);
                reject(new Error(`Failed to delete database: ${event.target.error}`));
            };

            request.onblocked = () => {
                console.warn(`Database ${db.name} deletion blocked — waiting for connections to close`);
            };
        }
    });
}

// Recovery never enumerates or removes other accounts' databases, authentication, or preferences.
export function deleteExactDatabase(name) {
    return new Promise((resolve, reject) => {
        const request = indexedDB.deleteDatabase(name);
        const timeout = setTimeout(() => resolve(false), 10_000);
        request.onsuccess = () => {
            clearTimeout(timeout);
            resolve(true);
        };
        request.onerror = () => {
            clearTimeout(timeout);
            reject(new Error("Could not clear saved data"));
        };
        // Keep waiting for other tabs' onversionchange handlers to release their connections.
        request.onblocked = () => {};
    });
}
